module.exports = __webpack_public_path__ + "static/media/services.c2ed38d7.jpg";